/* eslint-disable complexity */
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { FasCheck, FasAngleRight, FasAngleDown } from "assets/icons";
import { RequestStatus, safeTrim } from "protocol-setup/helpers";
import { titleAndAria } from "protocol-setup/constants/errorMessages";

export const getAriaLabel = (requestStatusIndex, isOpen, title, requestStatus, currentStatus) => {
  let status = RequestStatus[requestStatus] || requestStatus;
  if (currentStatus === 'RETIRED') {
    status = RequestStatus.RETIRED;
  } else if (currentStatus === 'CANCELED') {
    status = RequestStatus.CANCELED;
  }
  if (requestStatusIndex < 0) {
    return titleAndAria.updateNotAllowed(title, status);
  }
  if (requestStatusIndex === 0) {
    return titleAndAria.expandCollapse(isOpen, title);
  }
  return titleAndAria.cannotExpandCollapse(title, status);
};






const Accordian = ({
  title,
  status,
  open = false,
  requestStatusIndex,
  requestStatus,
  data,
  children,
  disable,
  currentStatus,
  enableHighlight = true,
  isSignOffEditable = true,
  headerAction,
  isEditMode = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isEditable = isEditMode || (requestStatusIndex === 0 && currentStatus !== 'RETIRED' && currentStatus !== 'CANCELED' && enableHighlight && isSignOffEditable);

  const toggleAccordion = () => {
    if (!disable) {
      setIsOpen(!isOpen);
    }
  };
  useEffect(() => {
    setIsOpen(open || requestStatusIndex === 0);
  }, [open, requestStatusIndex])

  return (
    <div
      className={`rounded shadow-sm px-4 py-3 mt-2 ${isEditable ? 'bg-yellow' : ''} ${disable ? 'bg-grey-disabled-light' : ''}`}
      data-testid="accordian"
    >
      <div className="d-flex justify-content-between">
        <button
          type="button"
          className={`fn-btn content-section-title col-12 ${disable ? 'color-grey-disabled' : ''}`}
          style={{ marginLeft: '-.75rem' }}
          onClick={toggleAccordion}
          aria-expanded={isOpen} 
          title={getAriaLabel(requestStatusIndex, isOpen, title, requestStatus, currentStatus)}
          aria-label={getAriaLabel(requestStatusIndex, isOpen, title, requestStatus, currentStatus)} // Added for screen reader accessibility
        >
          <div className="d-flex" >
            <div aria-hidden="true">
              <span
                className={`fn-btn ${disable ? 'color-grey-disabled' : ''}`}
              >
                {isOpen ? <FasAngleDown /> : <FasAngleRight />}
              </span>
              {(requestStatusIndex < 0 || (status === 'COMPLETED' && requestStatus === 'COMPLETED')) && (
                <span className="color-green mr-1"><FasCheck /></span>
              )}
              {title}
            </div>
          </div>
        </button>
        {data?.submitterName && data?.submittedDate && (
          <div className="font-sm font-normal font-italic color-black">
            ({safeTrim(data.submitterName)}) {data?.submittedDate?.replace(/\s[A-Z]{3,4}$/, '')}
          </div>
        )}
        {headerAction && (
          <div className="ml-2 mr-n1 d-flex align-items-center">
            {headerAction}
          </div>
        )}
      </div>
      {isOpen ? <div className="pl-2 ml-1">{children}</div> : null}
    </div>
  );
};

export default Accordian;
